import { Injectable } from '@angular/core';
import { DataModel } from 'common/models/utility-models/base-model';
import {
  GridModel,
  GridParams,
} from 'common/models/utility-models/list-utility.model';
import { BaseWidgetService } from './base-widget.service';
import { GridDataService } from 'common/services/data-services/base-data-services/grid-data.service';

@Injectable()
export abstract class GridWidgetService<
  T extends DataModel,
  G extends GridModel<T>
> extends BaseWidgetService<G> {
  [x: string]: any;
  protected queryparm = new GridParams();
  protected constructor(protected ds: GridDataService<G, T>) {
    super(ds);
  }

    override getListDataModel(queryParams: any, param = null): Promise<G> {
        return new Promise<G>((resolve, reject) => {
            this.ds
                .getGridData(queryParams, param)
                .then(data => {
                    resolve(data);
                })
                .catch(err => {
                    reject(err);
                });
        });
   
  }



  async deleteData(data): Promise<any> {
    return await this.ds.deleteData(data);
  }

  async updateStatus(data): Promise<any> {

    return await this.ds.updateGridStatusData(data);
  }

  // filterData(
  //   originalModel,
  //   filterModel,
  //   searchValue,
  //   searchableFields,
  //   pageModel
  // ): G[] {
  //   return this.ds.filterData(
  //     originalModel,
  //     filterModel,
  //     searchValue,
  //     searchableFields,
  //     pageModel
  //   );
  // }


  filterData(
    originalModel,
    filterModel,
    searchValue,
    searchableFields,
    pageModel,
    isMultipleFilter: boolean = false
  ): G[] {
    return this.ds.filterData(
      originalModel,
      filterModel,
      searchValue,
      searchableFields,
      pageModel,
      isMultipleFilter
    );
  }

  modifyqueryParam(data, originalModel): void {}

  processGridData(originalModel, queryParam): any {
    return this.ds.processGridData(originalModel, queryParam);
  }

  initGridExtras(event) {
    this.ds.initGridActions(event);
  }

  downloadSampleExcel():Promise<any>{
    return new Promise((resolve, reject) => {
      this.ds.downloadGridSampleExcel().then((data)=>{
        resolve(data);
      });
    })
   
  }
}
